import { render } from "./index.vue?vue&type=template&id=b340805a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=b340805a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b340805a"

export default script